import './inseason/style';
import FormStructure from './inseason/form_structure';

export default FormStructure;